export default [
  {
    "_index": "colorways_development_20190706143737041",
    "_type": "colorway",
    "_id": "4419",
    "_score": null,
    "sort": [
      5860001
    ],
    "color_family": "blue",
    "color": "Heather Navy",
    "nav_taxons": [
      "shop/girls",
      "shop/girls/just-in",
      "featured-products/summer-2019",
      "shop/girls-best-sellers",
      "shop/girls-new-arrivals",
      "shop/girls-new-arrivals/graphics",
      "shop/girls",
      "shop/girls/tops",
      "shop/girls/tops/graphics-shop"
    ],
    "nav_categories": [
      "Girls",
      "Just In",
      "Girls New Arrivals",
      "Graphics",
      "Girls",
      "Tops",
      "Graphics Shop"
    ],
    "skus": [
      {
        "size": [
          "6"
        ],
        "in_stock": true
      },
      {
        "size": [
          "8"
        ],
        "in_stock": true
      },
      {
        "size": [
          "7"
        ],
        "in_stock": true
      },
      {
        "size": [
          "5"
        ],
        "in_stock": true
      },
      {
        "size": [
          "12"
        ],
        "in_stock": true
      },
      {
        "size": [
          "10"
        ],
        "in_stock": true
      },
      {
        "size": [
          "3"
        ],
        "in_stock": true
      },
      {
        "size": [
          "4"
        ],
        "in_stock": true
      }
    ],
    "code": "5647-240",
    "category": [
      "Tops",
      "Graphic Tees"
    ],
    "description": "We're dreaming of sweet treats this summer thanks to a Zelda flip sequin ice cream cone on our comfy tri-blend you've got to feel to believe!",
    "details": "* 50% Polyester, 38% Cotton, 12% Rayon\r* Machine wash cold inside out\r* Only non-chlorine bleach\r* Tumble dry low\r* Cool iron if needed on reverse side only",
    "id": "1751-5647-240",
    "product_id": 1751,
    "product_slug": "rainbow-sequin-zelda-tee",
    "colorway_id": 4419,
    "name": "Rainbow Sequin Zelda Tee",
    "sort_order": [
      {
        "shop": 2150003
      },
      {
        "shop-girls-new-arrivals": 2150003
      },
      {
        "shop-girls-new-arrivals-graphics": 2150003
      },
      {
        "shop": 3300001
      },
      {
        "shop-girls-best-sellers": 3300001
      },
      {
        "shop": 450001
      },
      {
        "shop-girls": 450001
      },
      {
        "shop-girls-just-in": 450001
      },
      {
        "shop": 480002
      },
      {
        "shop-girls": 480002
      },
      {
        "shop-girls-tops": 480002
      },
      {
        "shop-girls-tops-graphics-shop": 480002
      },
      {
        "featured-products": 5860001
      },
      {
        "featured-products-summer-2019": 5860001
      }
    ],
    "style_number": "5647",
    "colorways": [
      {
        "id": 4419,
        "slug": "heathernavy",
        "color": "Heather Navy",
        "code": "5647-240",
        "shots": [
          {
            "id": 2688485,
            "shot_type": "back",
            "cloudinary_key": "production/catalog/cdwuwjsslhhgah2ajmr6"
          },
          {
            "id": 2688487,
            "shot_type": "detail",
            "cloudinary_key": "production/catalog/vj9vd5bdrppry8uzfqoy"
          },
          {
            "id": 2688486,
            "shot_type": "front",
            "cloudinary_key": "production/catalog/fnm4byyqsua0g0jj7dou"
          }
        ],
        "skus": [
          {
            "id": 19001,
            "sku": "5647-240-L",
            "size": "6",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19002,
            "sku": "5647-240-E",
            "size": "8",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19003,
            "sku": "5647-240-M",
            "size": "7",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19004,
            "sku": "5647-240-K",
            "size": "5",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19005,
            "sku": "5647-240-O",
            "size": "12",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19006,
            "sku": "5647-240-N",
            "size": "10",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19007,
            "sku": "5647-240-H",
            "size": "3",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19008,
            "sku": "5647-240-I",
            "size": "4",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          }
        ]
      }
    ]
  },
  {
    "_index": "colorways_development_20190706143737041",
    "_type": "colorway",
    "_id": "4404",
    "_score": null,
    "sort": [
      5860002
    ],
    "color_family": "pink",
    "color": "Pink Irridesent",
    "nav_taxons": [
      "shop/girls",
      "shop/girls/just-in",
      "featured-products/summer-2019",
      "shop/girls",
      "shop/girls/dresses-and-skirts",
      "shop/girls-best-sellers",
      "shop/girls-new-arrivals",
      "shop/girls-new-arrivals/dresses-and-skirts",
      "shop/girls-new-arrivals",
      "shop/girls-new-arrivals/wow-styles-girls"
    ],
    "nav_categories": [
      "Girls",
      "Just In",
      "Girls",
      "Dresses and Skirts",
      "Girls New Arrivals",
      "Dresses and Skirts",
      "Girls New Arrivals",
      "Just In"
    ],
    "skus": [
      {
        "size": [
          "4"
        ],
        "in_stock": true
      },
      {
        "size": [
          "7"
        ],
        "in_stock": true
      },
      {
        "size": [
          "12"
        ],
        "in_stock": true
      },
      {
        "size": [
          "10"
        ],
        "in_stock": true
      },
      {
        "size": [
          "5"
        ],
        "in_stock": true
      },
      {
        "size": [
          "3"
        ],
        "in_stock": true
      },
      {
        "size": [
          "6"
        ],
        "in_stock": true
      },
      {
        "size": [
          "8"
        ],
        "in_stock": true
      }
    ],
    "code": "7345-038",
    "category": [
      "Bottoms",
      "Skirts"
    ],
    "description": "Iridescent hot pink paillettes make this her new favorite skirt. Machine washability makes it yours. Plus, a jersey waistband and lining makes it way comfy, and totally \"oops\" proof.",
    "details": "* Skirt: 100% Polyester Lining: 100% Polyester\r* Machine wash cold, gentle cycle inside out\r* Only non-chlorine bleach\r* Tumble dry low\r* Cool iron if needed on reverse side only",
    "id": "1740-7345-038",
    "product_id": 1740,
    "product_slug": "pink-paillette-sequin-skirt",
    "colorway_id": 4404,
    "name": "Pink Paillette Sequin Skirt",
    "sort_order": [
      {
        "shop": 630034
      },
      {
        "shop-girls": 630034
      },
      {
        "shop-girls-dresses-and-skirts": 630034
      },
      {
        "shop": 3300004
      },
      {
        "shop-girls-best-sellers": 3300004
      },
      {
        "shop": 450002
      },
      {
        "shop-girls": 450002
      },
      {
        "shop-girls-just-in": 450002
      },
      {
        "shop": 2090011
      },
      {
        "shop-girls-new-arrivals": 2090011
      },
      {
        "shop-girls-new-arrivals-wow-styles-girls": 2090011
      },
      {
        "featured-products": 5860002
      },
      {
        "featured-products-summer-2019": 5860002
      },
      {
        "shop": 2170020
      },
      {
        "shop-girls-new-arrivals": 2170020
      },
      {
        "shop-girls-new-arrivals-dresses-and-skirts": 2170020
      }
    ],
    "style_number": "7345",
    "colorways": [
      {
        "id": 4404,
        "slug": "pinkirridesent",
        "color": "Pink Irridesent",
        "code": "7345-038",
        "shots": [
          {
            "id": 2692428,
            "shot_type": "back",
            "cloudinary_key": "production/catalog/vdj6k6biahzxtnixaqpr"
          },
          {
            "id": 2692429,
            "shot_type": "front",
            "cloudinary_key": "production/catalog/hygnreprlm2lt0damufj"
          }
        ],
        "skus": [
          {
            "id": 18870,
            "sku": "7345-038-I",
            "size": "4",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 18871,
            "sku": "7345-038-M",
            "size": "7",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 18872,
            "sku": "7345-038-O",
            "size": "12",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 18873,
            "sku": "7345-038-N",
            "size": "10",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 18874,
            "sku": "7345-038-K",
            "size": "5",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 18875,
            "sku": "7345-038-H",
            "size": "3",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 18876,
            "sku": "7345-038-L",
            "size": "6",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 18877,
            "sku": "7345-038-E",
            "size": "8",
            "price": 34.5,
            "cost_price": null,
            "in_stock": true
          }
        ]
      }
    ]
  },
  {
    "_index": "colorways_development_20190706143737041",
    "_type": "colorway",
    "_id": "4312",
    "_score": null,
    "sort": [
      5860003
    ],
    "color_family": "blue",
    "color": "Blue",
    "nav_taxons": [
      "shop/boys-new-arrivals",
      "shop/boys-new-arrivals/swim",
      "featured-products/summer-2019",
      "shop/boys",
      "shop/boys/swimwear",
      "shop/vacation"
    ],
    "nav_categories": [
      "Boys New Arrivals",
      "Swim",
      "Boys",
      "Swimwear"
    ],
    "skus": [
      {
        "size": [
          "OS"
        ],
        "in_stock": true
      }
    ],
    "code": "A222-C01",
    "category": [
      "Swim",
      "Swim Accessories"
    ],
    "description": "AHHHHHHH! The coolest goggles on the planet are here.",
    "details": "*90% silicone, 10% pc\r\n*UV protected & anti-fog lenses\r\n*Adjustable head strap",
    "id": "1665-A222-C01",
    "product_id": 1665,
    "product_slug": "monster-goggle",
    "colorway_id": 4312,
    "name": "Monster Goggle",
    "sort_order": [
      {
        "shop": 230023
      },
      {
        "shop-boys": 230023
      },
      {
        "shop-boys-swimwear": 230023
      },
      {
        "shop": 2350008
      },
      {
        "shop-boys-new-arrivals": 2350008
      },
      {
        "shop-boys-new-arrivals-swim": 2350008
      },
      {
        "featured-products": 5860003
      },
      {
        "featured-products-summer-2019": 5860003
      },
      {
        "shop": 2780049
      },
      {
        "shop-vacation": 2780049
      }
    ],
    "style_number": "A222",
    "colorways": [
      {
        "id": 4312,
        "slug": "blue",
        "color": "Blue",
        "code": "A222-C01",
        "shots": [
          {
            "id": 2707248,
            "shot_type": "front",
            "cloudinary_key": "production/catalog/uduxsics6nhvmvilwh16"
          }
        ],
        "skus": [
          {
            "id": 18009,
            "sku": "A222-C01-A",
            "size": "OS",
            "price": 24.5,
            "cost_price": null,
            "in_stock": true
          }
        ]
      },
      {
        "id": 4311,
        "slug": "moss",
        "color": "Moss",
        "code": "A222-D07",
        "shots": [
          {
            "id": 2707247,
            "shot_type": "front",
            "cloudinary_key": "production/catalog/dyv8xevmgetyztwk3ald"
          }
        ],
        "skus": [
          {
            "id": 18008,
            "sku": "A222-D07-A",
            "size": "OS",
            "price": 24.5,
            "cost_price": null,
            "in_stock": true
          }
        ]
      }
    ]
  },
  {
    "_index": "colorways_production_20190708213725142",
    "_type": "colorway",
    "_id": "4484",
    "_score": null,
    "sort": [
      2090010
    ],
    "color_family": "green",
    "color": "Pepper Green",
    "nav_taxons": [
      "shop/girls",
      "shop/girls/just-in",
      "shop/camp-shop",
      "shop/girls-new-arrivals",
      "shop/girls-new-arrivals/shorts",
      "shop/girls",
      "shop/girls/bottoms",
      "shop/girls/bottoms/shorts",
      "shop/girls-new-arrivals",
      "shop/girls-new-arrivals/wow-styles-girls"
    ],
    "nav_categories": [
      "Girls",
      "Just In",
      "Girls New Arrivals",
      "Shorts",
      "Girls",
      "Bottoms",
      "Shorts",
      "Girls New Arrivals",
      "Just In"
    ],
    "skus": [
      {
        "size": [
          "4"
        ],
        "in_stock": true
      },
      {
        "size": [
          "6"
        ],
        "in_stock": true
      },
      {
        "size": [
          "7"
        ],
        "in_stock": true
      },
      {
        "size": [
          "10"
        ],
        "in_stock": true
      },
      {
        "size": [
          "12"
        ],
        "in_stock": true
      },
      {
        "size": [
          "5"
        ],
        "in_stock": true
      },
      {
        "size": [
          "8"
        ],
        "in_stock": true
      },
      {
        "size": [
          "3"
        ],
        "in_stock": true
      }
    ],
    "code": "7254-300",
    "category": [
      "Bottoms",
      "Shorts"
    ],
    "description": "If these don't scream \"summer camp, 1982\" we don't know what does. Made from supersoft and quick-drying terrycloth, with convenient side pockets and a cute embroidered pineapple, these shorts for sure have a place in her weekly rotation.",
    "details": "* 65% Polyester, 35% Rayon\r* Machine wash cold gentle cycle\r* Only non-chlorine bleach\r* Tumble dry low\r* Cool iron if needed",
    "id": "1809-7254-300",
    "product_id": 1809,
    "product_slug": "towel-terry-track-short",
    "colorway_id": 4484,
    "name": "Towel Terry Track Short",
    "sort_order": [
      {
        "shop": 600012
      },
      {
        "shop-girls": 600012
      },
      {
        "shop-girls-bottoms": 600012
      },
      {
        "shop-girls-bottoms-shorts": 600012
      },
      {
        "shop": 3580007
      },
      {
        "shop-camp-shop": 3580007
      },
      {
        "shop": 450004
      },
      {
        "shop-girls": 450004
      },
      {
        "shop-girls-just-in": 450004
      },
      {
        "shop": 2090010
      },
      {
        "shop-girls-new-arrivals": 2090010
      },
      {
        "shop-girls-new-arrivals-wow-styles-girls": 2090010
      },
      {
        "shop": 2190002
      },
      {
        "shop-girls-new-arrivals": 2190002
      },
      {
        "shop-girls-new-arrivals-shorts": 2190002
      }
    ],
    "style_number": "7254",
    "colorways": [
      {
        "id": 4484,
        "slug": "peppergreen",
        "color": "Pepper Green",
        "code": "7254-300",
        "shots": [
          {
            "id": 2736986,
            "shot_type": "back",
            "cloudinary_key": "production/catalog/mu8h3v2gdaw8bf9sp3ui"
          },
          {
            "id": 2736987,
            "shot_type": "front",
            "cloudinary_key": "production/catalog/la6b2vceu6ivonfp3j8r"
          },
          {
            "id": 2736988,
            "shot_type": "on_model",
            "cloudinary_key": "production/catalog/wpnzyaxvwis3wfrb3xpb"
          }
        ],
        "skus": [
          {
            "id": 19579,
            "sku": "7254-300-I",
            "size": "4",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19580,
            "sku": "7254-300-L",
            "size": "6",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19581,
            "sku": "7254-300-M",
            "size": "7",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19582,
            "sku": "7254-300-N",
            "size": "10",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19583,
            "sku": "7254-300-O",
            "size": "12",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19584,
            "sku": "7254-300-K",
            "size": "5",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19585,
            "sku": "7254-300-E",
            "size": "8",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19586,
            "sku": "7254-300-H",
            "size": "3",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          }
        ]
      },
      {
        "id": 4485,
        "slug": "clearskyblue",
        "color": "Clear Sky Blue",
        "code": "7254-2B5",
        "shots": [
          {
            "id": 2736998,
            "shot_type": "back",
            "cloudinary_key": "production/catalog/ysjye2byyklzm2qade0r"
          },
          {
            "id": 2736999,
            "shot_type": "front",
            "cloudinary_key": "production/catalog/lyvrgfbajuuwq2w6jfxu"
          }
        ],
        "skus": [
          {
            "id": 19587,
            "sku": "7254-2B5-I",
            "size": "4",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19588,
            "sku": "7254-2B5-O",
            "size": "12",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19589,
            "sku": "7254-2B5-L",
            "size": "6",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19590,
            "sku": "7254-2B5-N",
            "size": "10",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19591,
            "sku": "7254-2B5-K",
            "size": "5",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19592,
            "sku": "7254-2B5-M",
            "size": "7",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19593,
            "sku": "7254-2B5-E",
            "size": "8",
            "price": 22.5,
            "cost_price": null,
            "in_stock": true
          },
          {
            "id": 19594,
            "sku": "7254-2B5-H",
            "size": "3",
            "price": 22.5,
            "cost_price": null,
            "in_stock": false
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/contentful/productQuartet/defaultProps.js